import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const THIRD_PARTY_ALLOWED = ['/third-party-report', '/third-party-terms'];

const ThirdPartyRoute = () => {
  const { token, userType } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!token) {
    return <Navigate to="/auth/login-1" replace />;
  }

  if (userType === 'THIRD_PARTY' && !THIRD_PARTY_ALLOWED.includes(location.pathname)) {
    return <Navigate to="/third-party-report" replace />;
  }

  return <Outlet />;
};

export default ThirdPartyRoute;
